export type NumericInputValue = number | string;

const decimalInputPattern = /^-?(?:\d+|\d*\.\d*)?$/;
const integerInputPattern = /^\d*$/;

export function isAllowedDecimalInput(value: string) {
  return decimalInputPattern.test(value);
}

export function isAllowedIntegerInput(value: string) {
  return integerInputPattern.test(value);
}

export function parseNumericInput(value: NumericInputValue) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed === '-' || trimmed === '.' || trimmed === '-.') {
    return null;
  }

  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}
